// Conditions d'utilisation : numéro de version et date d'effet, partagés entre le texte affiché
// (src/components/legal/TermsOfUse.tsx) et le serveur (functions/api/conditions-utilisation.js).
//
// UN SEUL ENDROIT : si le texte change sur le fond, on change CETTE version et rien d'autre — chaque
// utilisateur est alors invité à ré-accepter, et l'historique garde l'ancienne ligne intacte. Une simple
// correction de typographie ne change pas la version (sinon tout le monde revalide pour une virgule).
// 2026-10-27 : article 12, clause sur les taux de TVA (proposés à titre d'aide, choisis et confirmés par l'Établissement).
export const CGU_VERSION = '2026-10-27';
export const CGU_DATE_EFFET = '27 octobre 2026';
